document.addEventListener("DOMContentLoaded", () => {
  const initializedSlots = new WeakSet();

  function setSlotFailed(slot) {
    slot.classList.add("restaurant-google-photo--failed");
    slot
      .querySelectorAll(
        ".restaurant-card-media__image, .restaurant-google-photo__image, .restaurant-card-media__attribution, .restaurant-google-photo__attribution, .restaurant-google-maps-logo",
      )
      .forEach((element) => element.remove());
  }

  function bindSlot(slot) {
    if (initializedSlots.has(slot)) {
      return;
    }

    initializedSlots.add(slot);

    const image = slot.querySelector(
      ".restaurant-card-media__image, .restaurant-google-photo__image",
    );
    if (!image) {
      setSlotFailed(slot);
      return;
    }

    image.addEventListener("error", () => setSlotFailed(slot), { once: true });

    if (image.complete && image.naturalWidth === 0) {
      setSlotFailed(slot);
    }
  }

  function loadRestaurantGooglePhotos(root = document) {
    root.querySelectorAll("[data-restaurant-google-photo]").forEach(bindSlot);
  }

  window.BMTG = window.BMTG || {};
  window.BMTG.loadRestaurantGooglePhotos = loadRestaurantGooglePhotos;

  loadRestaurantGooglePhotos();
});
